import * as React from 'react';
import Button from '../button';
import ActionButton from '../_util/ActionButton';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale/default';
import { getRenderPropValue } from '../_util/getRenderPropValue';
import { ConfigContext } from '../config-provider';
export const Overlay = props => {
    const { prefixCls, okButtonProps, cancelButtonProps, title, cancelText, okText, okType, icon, showCancel = true, close, onConfirm, onCancel, } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    return (<LocaleReceiver componentName="Popconfirm" defaultLocale={defaultLocale.Popconfirm}>
            {(contextLocale) => (<div className={`${prefixCls}-inner-content`}>
                    <div className={`${prefixCls}-message`}>
                        {icon}
                        <div className={`${prefixCls}-message-title`}>
                            {getRenderPropValue(title)}
                        </div>
                    </div>
                    <div className={`${prefixCls}-buttons`}>
                        {showCancel && (<Button onClick={onCancel} size="small" {...cancelButtonProps}>
                                {/* 多包裹个fragment hack样式 */}
                                <>
                                    {cancelText !== null && cancelText !== void 0 ? cancelText : contextLocale.cancelText}
                                </>
                            </Button>)}
                        <ActionButton buttonProps={Object.assign({ size: 'small', type: okType }, okButtonProps)} actionFn={onConfirm} close={close} prefixCls={getPrefixCls('btn')} quitOnNullishReturnValue emitEvent>
                            {/* 多包裹个fragment hack样式 */}
                            <>
                                {okText !== null && okText !== void 0 ? okText : contextLocale.okText}
                            </>
                        </ActionButton>
                    </div>
                </div>)}
        </LocaleReceiver>);
};
